import $ from "jquery";
$(function () {
  const menuHamburger = document.querySelector('.menu-hamburger');
  const menu = document.querySelector('.menu');
  const menuSection = menu.querySelector('.menu-section');
  const menuArrow = menu.querySelector('.menu-mobile-arrow');
  const menuToggle = document.querySelector('.menu-mobile-toggle');
  const menuOverlay = document.querySelector('.overlay');

  let subMenu = null;       // currently active panel (.menu-subs or .menu-subs-2)
  let parentSubMenu = null; // Level-2 panel saved when drilling to Level-3

  // ── Click delegation ────────────────────────────────────────
  menuSection.addEventListener('click', (e) => {
    if (!menu.classList.contains('active')) return;

    // Inside an already-open Level-2 panel → check for Level-2→3 drill
    const activeLvl2 = e.target.closest('.menu-subs.active');
    if (activeLvl2) {
      const column = e.target.closest('.mega-menu__column.menu-item-has-children');
      // Only trigger if click is on the column header row, not inside an already-open sub-panel
      if (column && !e.target.closest('.menu-subs-2')) {
        showSubMenuLvl3(column);
      }
      return;
    }

    // Level-1 → Level-2
    const hasChildren = e.target.closest('.menu-item-has-children');
    if (hasChildren) {
      showSubMenu(hasChildren);
    }
  });

  menuArrow.addEventListener('click', () => {
    hideSubMenu();
  });

  menuToggle.addEventListener('click', () => {
    toggleMenu();
  });

  menuOverlay.addEventListener('click', () => {
    toggleMenu();
  });

  // ── Toggle main menu ────────────────────────────────────────
  function toggleMenu() {
    menu.classList.toggle('active');
    menuHamburger.classList.toggle('open');
    menuOverlay.classList.toggle('active');
    if (menu.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      parentSubMenu = null;
    }
  }

  // ── Level 1 → Level 2 ────────────────────────────────────────
  function showSubMenu(hasChildren) {
    subMenu = hasChildren.querySelector('.menu-subs');
    if (!subMenu) return;
    subMenu.classList.add('active');
    subMenu.style.animation = 'slideLeft 0.5s ease forwards';
    const titleLink = hasChildren.querySelector('.menu-link > a');
    menu.querySelector('.menu-mobile-title').innerHTML = titleLink ? titleLink.textContent.trim() : '';
    menu.querySelector('.menu-mobile-header').classList.add('active');
  }

  // ── Level 2 → Level 3 ────────────────────────────────────────
  function showSubMenuLvl3(column) {
    const subSub = column.querySelector(':scope > .menu-subs-2');
    if (!subSub) return;
    parentSubMenu = subMenu;   // remember Level-2 panel
    subMenu = subSub;
    subMenu.classList.add('active');
    void subMenu.offsetWidth; // force reflow so animation fires after display:none→block
    subMenu.style.animation = 'slideLeft 0.5s ease forwards';
    const titleLink = column.querySelector('.menu-link-subs > a');
    menu.querySelector('.menu-mobile-title').innerHTML = titleLink ? titleLink.textContent.trim() : '';
  }

  // ── Back navigation ─────────────────────────────────────────
  function hideSubMenu() {
    if (!subMenu) return;

    const closing = subMenu;
    closing.style.animation = 'slideRight 0.5s ease forwards';
    setTimeout(() => {
      closing.classList.remove('active');
    }, 300);

    if (parentSubMenu) {
      // Level 3 → Level 2: restore Level-2 title
      subMenu = parentSubMenu;
      parentSubMenu = null;
      const topItem = subMenu.closest('.menu-item-has-children');
      const titleLink = topItem ? topItem.querySelector('.menu-link > a') : null;
      menu.querySelector('.menu-mobile-title').innerHTML = titleLink ? titleLink.textContent.trim() : '';
    } else {
      // Level 2 → Level 1
      subMenu = null;
      menu.querySelector('.menu-mobile-title').innerHTML = '';
      menu.querySelector('.menu-mobile-header').classList.remove('active');
    }
  }

  // ── Resize ──────────────────────────────────────────────────
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1023) {
      if (menu.classList.contains('active')) {
        toggleMenu();
      }
    }
  });
});
